import util from "config/utils";

const localStorageEffect =
  (key: string) => ({ setSelf, onSet }: { setSelf: any, onSet: any }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue !== null) {
      setSelf(util.decrypt(savedValue));
    }
    onSet((newValue: any) => {
      if (newValue === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, util.encrypt(newValue));
      }
    });
  };
export default localStorageEffect;